import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import React from 'react'

import * as selectors from '../game.selectors'
import * as Errors from '../../Errors'
import DataConsumeWarning from '../../../Mars/DataConsumeWarning'

/**
 *  Generic game error container.
 *  It renders an specific error according with the current error defined in
 *  game store.
 */
class GameError extends React.Component {
  /**
   *  Component will mount.
   */
  UNSAFE_componentWillMount() {
    this.ERRORS = {
      [Errors.CRITICAL]: this.renderCriticalError.bind(this),
      [Errors.DATA_CONSUME]: this.renderDataConsumeError.bind(this),
      [Errors.DEMO_FINISHED]: this.renderDemoFinishError.bind(this),
      [Errors.LOGIN_ERROR]: this.renderLoginError.bind(this),
      [Errors.PORTRAIT_ERROR]: this.renderPortraitError.bind(this),
      [Errors.UNSUPPORTED_DEVICE_ERROR]: this.renderUnsupportedDeviceError.bind(this),
    }
  }
  /**
   *  Render error.
   */
  renderError(icon, message) {
    return <FormattedMessage id={message} className={icon} />
  }

  /**
   *  Render critical error.
   */
  renderCriticalError() {
    return (
      <div className="container background--mars">
        <div className="content">
          <div className="alerts">
            <div className="alert--title">
              <FormattedMessage id="errors.critical_error" />
            </div>
            <div className="alert--message">
              <FormattedMessage id="errors.critical_error_description" />
            </div>
            <div className="icon-execute"></div>
          </div>
        </div>
      </div>
    )
  }

  /**
   *  Render Data Consume error.
   */
  renderDataConsumeError() {
    return <DataConsumeWarning />
  }

  /**
   *  Render demo finished error.
   */
  renderDemoFinishError() {
    return (
      <div>
        <div className="background-container">
          <div className="background-item background-findemo"></div>
        </div>
        <div className="wrapper-end-turn demo">
          <h1 className="h1">
            <FormattedMessage id="endDemo.title" />
          </h1>
          <ul className="end-demo">
            <li>
              <p>
                <FormattedMessage id="endDemo.text1" />
              </p>
              <p>
                <FormattedMessage id="endDemo.text2" />
              </p>
              <p>
                <FormattedMessage id="endDemo.text3" />
              </p>
            </li>
          </ul>
        </div>
      </div>
    )
  }

  /**
   *  Render login error.
   */
  renderLoginError() {
    return 'login-error', 'errors.login_error'
  }

  /**
   *  Render portrait error.
   */
  renderPortraitError() {
    return (
      <div className="container background--mars">
        <div className="content">
          <div className="alerts">
            <div className="alert--title">
              <FormattedMessage id="portraitError.title" />
            </div>
            <div className="alert--message">
              <FormattedMessage id="portraitError.failed" />
            </div>
            <div className="icon-mobile-landscape"></div>
          </div>
        </div>
      </div>
    )
  }

  /**
   *  Render unsupported device error.
   */
  renderUnsupportedDeviceError() {
    return this.renderError('unsupported-device-error', 'errors.unsupported_device_error')
  }

  /**
   *  Render component.
   */
  render() {
    const { currentError } = this.props

    return <div className={'error-container'}>{this.ERRORS[currentError]()}</div>
  }
}

GameError.propTypes = {
  currentError: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    currentError: selectors.getCurrentError(state),
  }
}

export default connect(mapStateToProps)(GameError)
